import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc } from '../docHelpers';

const getV10APIs = (userInfo) => {
  return [
    {
      title: '정산내역 조회',
      url: '/doc/정산내역 조회',
      data: [
        {
          version: 'v1.0',
          url: '/calculate/list',
          method: 'POST',
          desc: apiDocDesc({
            items: [
              '정산내역을 조회합니다.',
              '쇼핑몰 정산 페이지에서 수집된 정산관련 정보를 보여줍니다.',
              '쇼핑몰에서 취합된 데이터이므로 PLAYAUTO 2.0 주문과리에 없는 데이터가 노출될 수 있습니다.',
            ],
          }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: 'N',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 시작 카운트', defaultValue: '0' }),
            },
            {
              title: 'limit',
              required: 'N',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 정산내역 갯수', defaultValue: '100' }),
            },
            {
              title: 'orderbyType',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '정렬타입', defaultValue: 'DESC', allowedValues: ['ASC', 'DESC'] }),
            },
            {
              title: 'orderbyColumn',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '정렬대상',
                defaultValue: 'sett_com_date',
                allowedValues: [
                  ['sett_com_date', '<strong>정산완료일</strong>'],
                  ['sales', '<strong>판매가</strong>'],
                  ['sett_price', '<strong>정산금액</strong>'],
                ],
              }),
            },
            {
              title: 'search_key',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '검색 키',
                allowedValues: [
                  ['shop_ord_no', '<strong>주문번호</strong>'],
                  ['shop_sale_name', '<strong>온라인상품명</strong>'],
                  ['order_name', '<strong>주문자명</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'search_word',
              required: 'N',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'sdate',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '검색시작일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'edate',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'shop_cd',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '쇼핑몰코드', sub: '(옥션:A001, 지마켓:A006, 11번가:A112, 바이즐:A027...)' }),
            },
            {
              title: 'shop_id',
              required: 'N',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'sett_status',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '정산상태', allowedValues: ['정산완료', '미정산'] }),
            },
            {
              title: 'sett_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '정산구분', allowedValues: ['상품대금', '배송비'] }),
            },
            {
              title: 'masking_yn',
              required: 'N',
              type: 'Boolean',
              desc: apiParamDesc({ title: '개인정보 마스킹 처리 여부', defaultValue: 'false' }),
            },
          ],
          body_example: {
            start: 0,
            limit: 100,
            orderbyColumn: 'sett_com_date',
            orderbyType: 'desc',
            search_key: 'order_name',
            search_type: 'partial',
            search_word: '김바보',
            sdate: '2001-01-01',
            edate: '2021-01-21',
          },
          response: [
            {
              title: 'results',
              required: 'Y',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'sett_uniq',
              required: 'Y',
              type: 'Number',
              desc: '정산고유번호',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'Y',
              type: 'datetime',
              desc: '등록일',
              indent: 1,
            },
            {
              title: 'mdate',
              required: 'Y',
              type: 'datetime',
              desc: '수정일',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'Y',
              type: 'String',
              desc: '쇼핑몰코드',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'Y',
              type: 'String',
              desc: '쇼핑몰아이디',
              indent: 1,
            },
            {
              title: 'shop_ord_no',
              required: 'Y',
              type: 'String',
              desc: '주문번호',
              indent: 1,
            },
            {
              title: 'sett_type',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '정산타입', allowedValues: ['상품대금', '배송비'] }),
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'Y',
              type: 'String',
              desc: '상품명',
              indent: 1,
            },
            {
              title: 'order_name',
              required: 'Y',
              type: 'String',
              desc: '주문자명',
              indent: 1,
            },
            {
              title: 'sett_com_date',
              required: 'Y',
              type: 'String',
              desc: '정산완료일',
              indent: 1,
            },
            {
              title: 'sales',
              required: 'Y',
              type: 'Number',
              desc: '판매가(부가세포함)',
              indent: 1,
            },
            {
              title: 'deduct_price',
              required: 'Y',
              type: 'Number',
              desc: '공제금액',
              indent: 1,
            },
            {
              title: 'sett_price',
              required: 'Y',
              type: 'Number',
              desc: '정산금액',
              indent: 1,
            },
            {
              title: 'sett_status',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '정산완료여부', allowedValues: ['정산완료', '미정산'] }),
              indent: 1,
            },
            {
              title: 'recordsTotal',
              required: 'Y',
              type: 'Number',
              desc: '총 카운트',
            },
          ],
          response_example: {
            results: [
              {
                sett_uniq: '7380449818631130232',
                wdate: '2020-09-09 08:01:38',
                mdate: '2020-09-09 08:01:38',
                shop_cd: 'A112',
                shop_id: 'torimall',
                shop_ord_no: '202008294313129',
                sett_type: '상품대금',
                shop_sale_name: '로얄벤톤 헤세드 뚝배기 내열냄비 대 (베이지)',
                order_name: '김바보',
                sett_com_date: '2020-09-11',
                sales: 28000,
                deduct_price: 4480,
                sett_price: 23520,
                sett_status: '정산완료',
              },
            ],
            recordsTotal: 11956,
          },
        },
      ],
    },
    {
      title: '주문관리 정산 조회',
      url: '/doc/주문관리 정산 조회',
      data: [
        {
          version: 'v1.0',
          url: '/calculate/listOfOrder',
          method: 'POST',
          desc: apiDocDesc({ items: ['주문관리 정산내역을 조회합니다.', 'PLAYAUTO 2.0에 수집된 주문정보를 바탕으로 정산데이터를 보여줍니다.'] }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: 'N',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 시작 카운트', defaultValue: '0' }),
            },
            {
              title: 'limit',
              required: 'N',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 정산내역 갯수', defaultValue: '100' }),
            },
            {
              title: 'orderbyType',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '정렬타입', defaultValue: 'DESC', allowedValues: ['ASC', 'DESC'] }),
            },
            {
              title: 'orderbyColumn',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '정렬대상',
                defaultValue: 'sett_com_date',
                allowedValues: [
                  ['sett_com_date', '<strong>정산완료일</strong>'],
                  ['pay_time', '<strong>결제완료일</strong>'],
                  ['sales', '<strong>판매금액</strong>'],
                  ['sett_price', '<strong>정산금액</strong>'],
                  ['deduct_price', '<strong>공제금액</strong>'],
                ],
              }),
            },
            {
              title: 'search_key',
              required: 'N',
              type: 'String',
              desc: '검색 키',
            },
            {
              title: 'search_word',
              required: 'N',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'date_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '검색일',
                defaultValue: 'pay_time',
                allowedValues: ['pay_time', 'sett_com_date'],
              }),
            },
            {
              title: 'sdate',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '검색시작일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'edate',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'shop_cd',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰코드',
                sub: '(옥션: A001, 지마켓: A006, 11번가: A112, 바이즐: A027...)',
              }),
            },
            {
              title: 'shop_id',
              required: 'N',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'sett_status',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '정산상태', allowedValues: ['정산완료', '미정산'] }),
            },
            {
              title: 'sett_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '정산구분', allowedValues: ['상품대금', '배송비'] }),
            },
            {
              title: 'ord_status',
              required: 'N',
              type: 'String',
              desc: '주문상태',
            },
            {
              title: 'masking_yn',
              required: 'N',
              type: 'Boolean',
              desc: apiParamDesc({ title: '개인정보 마스킹 처리 여부', defaultValue: 'false' }),
            },
          ],
          body_example: {
            start: 0,
            limit: 100,
            orderbyColumn: 'sett_com_date',
            orderbyType: 'desc',
            search_key: 'shop_ord_no',
            search_type: 'partial',
            search_word: '20210107457993-001-001-001',
            sdate: '2001-01-01',
            edate: '2021-01-21',
          },
          response: [
            {
              title: 'results',
              required: 'Y',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'sol_no',
              required: 'Y',
              type: 'Number',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'uniq',
              required: 'Y',
              type: 'Number',
              desc: '주문고유번호',
              indent: 1,
            },
            {
              title: 'ori_uniq',
              required: 'Y',
              type: 'Number',
              desc: apiParamDesc({ title: '원본주문고유번호', sub: '(사본인 경우)' }),
              indent: 1,
            },
            {
              title: 'pay_time',
              required: 'Y',
              type: 'datetime',
              desc: '결제완료일',
              indent: 1,
            },
            {
              title: 'shop_name',
              required: 'Y',
              type: 'String',
              desc: '쇼핑몰명',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'Y',
              type: 'String',
              desc: '쇼핑몰코드',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'Y',
              type: 'String',
              desc: '쇼핑몰아이디',
              indent: 1,
            },
            {
              title: 'shop_ord_no',
              required: 'Y',
              type: 'String',
              desc: '주문번호',
              indent: 1,
            },
            {
              title: 'ord_status',
              required: 'Y',
              type: 'String',
              desc: '주문상태',
              indent: 1,
            },
            {
              title: 'exchange_ord_yn',
              required: 'Y',
              type: 'Number',
              desc: apiParamDesc({ title: '교환주문여부', allowedValues: ['1', '0'] }),
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'Y',
              type: 'String',
              desc: '상품명',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'Y',
              type: 'String',
              desc: '쇼핑몰 상품번호',
              indent: 1,
            },
            {
              title: 'order_name',
              required: 'Y',
              type: 'String',
              desc: '주문자명',
              indent: 1,
            },
            {
              title: 'c_sale_cd',
              required: 'Y',
              type: 'String',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'sett_type',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '정산타입', allowedValues: ['상품대금', '배송비'] }),
              indent: 1,
            },
            {
              title: 'sett_com_date',
              required: 'Y',
              type: 'date',
              desc: '정산완료일',
              indent: 1,
            },
            {
              title: 'sales',
              required: 'Y',
              type: 'Number',
              desc: '판매가',
              indent: 1,
            },
            {
              title: 'sett_price',
              required: 'Y',
              type: 'Number',
              desc: '정산금액',
              indent: 1,
            },
            {
              title: 'deduct_price',
              required: 'Y',
              type: 'Number',
              desc: '공제금액',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'Y',
              type: 'String',
              desc: 'sku코드',
              indent: 1,
            },
            {
              title: 'sett_yn',
              required: 'Y',
              type: 'Number',
              desc: apiParamDesc({ title: '정산완료여부', sub: '(1: 정산완료, 0: 미정산)', allowedValues: ['1', '0'] }),
              indent: 1,
            },
            {
              title: 'recordsTotal',
              required: 'Y',
              type: 'Number',
              desc: '총 카운트',
            },
          ],
          response_example: {
            results: [
              {
                sol_no: 1,
                uniq: 1013238227879967200,
                ori_uniq: null,
                pay_time: '2021-01-07 00:00:01',
                shop_name: '홈앤쇼핑',
                shop_cd: 'B614',
                shop_id: 'e109572',
                shop_ord_no: '20210107457993-001-001-001',
                ord_status: '신규주문',
                exchange_ord_yn: 0,
                shop_sale_name:
                  '[30M] 38평형 외풍차단 난방비절약 투명 창틀 바람막이 문풍지 1M*30개',
                shop_sale_no: '20114947 001',
                order_name: '김바보',
                c_sale_cd: '',
                sett_type: null,
                sett_com_date: null,
                sales: 19710,
                sett_price: null,
                deduct_price: null,
                sku_cd: null,
                sett_yn: 0,
              },
            ],
            recordsTotal: 1,
          },
        },
      ],
    },
    {
      title: 'SKU별 추정 매출현황 조회',
      url: '/doc/SKU별 추정 매출현황 조회',
      data: [
        {
          version: 'v1.0',
          url: '/calculate/state-per-prod-list',
          method: 'POST',
          desc: apiDocDesc({ items: ['SKU별 추정 매출 현황 데이터를 조회합니다.'] }),
          header: default_header,
          header_example: default_header_example,
          authorized_sol_ser: ['cal_state_per_prod'],
          body: [
            {
              title: 'start',
              required: 'N',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 시작 카운트', defaultValue: '0' }),
            },
            {
              title: 'length',
              required: 'N',
              type: 'Number',
              desc: apiParamDesc({ title: '조회할 현황 카운트', defaultValue: '100' }),
            },
            {
              title: 'date_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '날짜검색타입',
                defaultValue: 'wdate',
                allowedValues: [
                  ['wdate', '<strong>주문수집일</strong>'],
                  ['ord_time', '<strong>주문일</strong>'],
                  ['pay_time', '<strong>결제완료일</strong>'],
                ],
              }),
            },
            {
              title: 'sku_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: 'SKU 타입',
                defaultValue: 'all',
                allowedValues: [
                  ['all', '<strong>전체(SKU상품, 세트상품)</strong>'],
                  ['single', '<strong>SKU상품</strong>'],
                  ['set', '<strong>세트상품</strong>'],
                ],
              })
            },
            {
              title: 'search_key',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '검색 키',
                defaultValue: '__ALL__',
                allowedValues: ['__ALL__', 'sku_cd', 'set_cd', 'shop_ord_no'],
              })
            },
            {
              title: 'search_word',
              required: 'N',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '검색타입',
                defaultValue: 'partial',
                allowedValues: [['exact', '<strong>완전일치</strong>'], ['partial', '<strong>부분일치</strong>']],
              }),
            },
            {
              title: 'sdate',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '검색시작일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'edate',
              required: 'Y',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'shop_cd',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({ title: '쇼핑몰코드', sub: '(옥션:A001, 지마켓:A006, 11번가:A112, 바이즐:A027...)' }),
            },
            {
              title: 'shop_id',
              required: 'N',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'multi_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '멀티검색 키',
                allowedValues: [
                  ['sku_cd', '<strong>SKU코드</strong>'],
                  ['set_cd', '<strong>세트SKU코드</strong>'],
                  ['shop_sale_no', '<strong>쇼핑몰 상품코드</strong>'],
                  ['c_sale_cd', '<strong>판매자관리코드</strong>'],
                ],
              }),
            },
            {
              title: 'multi_search_word',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '멀티검색어 ( \\n 으로 묶어서 전송 ) ex> 하나\\n둘\\n셋\\n넷' }),
            },
            {
              title: 'status',
              required: 'N',
              type: 'String',
              desc: apiParamDesc({
                title: '주문상태',
                sub: '전체조회시 "전체"',
                allowedValues: ['신규주문', '주문보류', '출고대기', '출고보류', '운송장출력', '출고완료', '배송중', '배송완료', '구매결정', '클레임'],
              })
            }
          ],
          body_example: {
            start: 0,
            length: 100,
            orderby: 'wdate desc',
            search_key: 'sku_cd',
            search_word: '테스트 검색어',
            search_type: 'partial',
            date_type: 'wdate',
            sdate: '2023-12-30',
            edate: '2024-12-30',
            shop_id: 'myshopy3',
            shop_cd: 'A001',
            sku_type: 'all',
            multi_search_word: '테스트멀티검색어1\n테스트멀티검색어2',
            multi_type: 'sku_cd',
            status: '클레임'
          },
          response: [
            {
              title: 'results',
              required: 'Y',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'recordsTotal',
              required: 'Y',
              type: 'Number',
              desc: '주문 카운트',
            },
            {
              title: 'recordsTotalCount',
              required: 'Y',
              type: 'Number',
              desc: '총 카운트',
            },
          ],
          response_example: {
            results: [
                {
                    sol_no: 81419,
                    uniq: "1706541309474214479",
                    bundle_no: 3936697852000721,
                    set_no: null,
                    prod_no: 33961382,
                    depot_no: 140570,
                    set_cd: null,
                    sku_cd: "TEST_SKU_CD",
                    prod_name: "TEST_PROD_NAME",
                    stock_cd: "TEST_STOCK_CD",
                    cost_price: 97440,
                    supply_price: 0,
                    list_price: 0,
                    opt_sale_cnt: 1,
                    pack_unit: 1,
                    shop_sale_no: "10",
                    shop_cd: "B616",
                    shop_id: "test_id",
                    pa_shop_cd: null,
                    c_sale_cd: "",
                    shop_name: "테스트",
                    order_id: "TEST_ID",
                    shop_cost_price: 100000,
                    shop_supply_price: 0,
                    discount_amt: 0,
                    pay_amt: 0,
                    sales: 10000,
                    sales_per: null,
                    total_out_qty: 1,
                    estimate_sales: "10000.00",
                    ord_status: "신규주문",
                    wdate: "2024-04-25 16:38:45",
                    ord_time: "2024-03-27 15:41:13",
                    pay_time: "0001-01-01 00:00:00",
                    shop_ord_no: "20240327-0000010",
                    shop_sale_name: "샘플상품 2",
                    shop_opt_name: "",
                    ship_plan_date: null,
                    depot_name: "테스트입니다",
                    exchange_ord_yn: 1,
                    order_name: "테스트",
                    to_name: "테스트",
                    ship_msg: "",
                    to_zipcd: "08390",
                    to_addr1: "서울특별시 구로구 디지털로26길 123 (구로동) 지플러스타워",
                    invoice_no: null,
                    ship_cost: 0,
                    order_tel: "010-0000-0000",
                    order_htel: "010-0000-0000",
                    to_tel: "010-0000-0000",
                    to_htel: "010-0000-0000",
                    avg_sales: 10000,
                    supp_name: null,
                    memo_yn: 0,
                    memo_complete_yn: 0
                }
            ],
            recordsTotal: 1,
            recordsTotalCount: 1
        },
        },
      ]
    }
  ];
};

export default getV10APIs;